export const SITES_ROUTES = {
  __ROOT__: '/sites',
  EDIT_SITE: '/sites/edit/:siteId',
  NEW_SITE: '/sites/new',
  VIEW_SITE: '/sites/view/:siteId',
}

export const SITES_LIST_LIMIT = 10000
